import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {Container, Row, Col} from '@modifi/ui'
import {AbilityContextProvider} from '@modifi/plugin-authorization'
import {AnnouncementBanner} from '@modifi/plugin-banners'

import {abilityFactory} from '../constants/permissions'

import Header from './header'
import GlobalStyle from '../styles/global'
import {ModifiUiAppSized} from '../styles/common'

const ability = abilityFactory()

const Layout = ({
  children,
  loading,
  fetchAnnouncementData,
  locale,
  hasAnyAnnouncements,
  ...restProps
}) => {
  useEffect(() => {
    fetchAnnouncementData && fetchAnnouncementData(locale, 'riskOffice')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchAnnouncementData])

  if (loading) {
    return null
  }
  return (
    <AbilityContextProvider ability={ability}>
      <ModifiUiAppSized>
        <Header {...restProps} />
        {children && (
          <Container mt={80} fluid>
            {hasAnyAnnouncements && (
              <Row justifyContent="center" mt={16}>
                <Col>
                  <AnnouncementBanner />
                </Col>
              </Row>
            )}
            {children}
          </Container>
        )}
        <GlobalStyle />
      </ModifiUiAppSized>
    </AbilityContextProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  fetchAnnouncementData: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  hasAnyAnnouncements: PropTypes.bool.isRequired,
}

Layout.defaultProps = {
  children: null,
  loading: false,
}

export default Layout
